import axiosInstance from "./api_instance";

export const getItemEventDetail = (slug) => {
  return axiosInstance.get(`client/events/${slug}`);
};

export const getMatchResultEvent = (slug) => {
  return axiosInstance.get(`client/events/${slug}/score`);
};
